import { type CSSProperties } from 'typestyle/lib/types';

const leftoverColumns = (gridColumnWidth?: number): CSSProperties => ({
  flexShrink: 0,
  minWidth: gridColumnWidth,
});

export default leftoverColumns;
